import React from 'react'

import Head from 'next/head'

interface HeadType {
  title: string
  description: string
  children?: React.ReactNode | JSX.Element
}

const HeadSeo: React.FC<HeadType> = ({ title = 'ENUYGUN', description = 'ENUYGUN', children }) => {
  return (
    <Head>
      <title>{title}</title>
      <meta property="og:title" content={title} />
      <meta name="description" content={description} />
      <meta property="og:description" content={description} />
      {children}
    </Head>
  )
}

export default HeadSeo
